import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { RegisterTaxTypeComponent } from '../register-tax-type/register-tax-type.component';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TaxTypeTableModel } from 'src/app/models/tables/management/tax-type-table.model';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { TaxTypeModel } from 'src/app/models/management/tax-type.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { UserModel } from 'src/app/models/authentication/user.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { TaxTypeService } from 'src/app/services/management/tax-type.service';
import { WindowEnums } from 'src/app/enum/window-enums';
@Component({
  selector: 'app-tax-type',
  templateUrl: './tax-type.component.html',
  styleUrls: ['./tax-type.component.scss'],
  standalone: false
})
export class TaxTypeComponent implements OnInit {
  @ViewChild('taxTypeModal') taxTypeModalComponent?: CustomModalComponent | null = null;
  componentRegisterTaxType = RegisterTaxTypeComponent;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  data: PagedResponseModel<TaxTypeTableModel> = new PagedResponseModel<TaxTypeTableModel>();
  header: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  inputsForTaxType$ = new BehaviorSubject<any>({
    taxTypeModel: new TaxTypeModel,
  });
  limit: number = 10;
  nameWindow: string = 'Tipo Impuesto';
  outputForTaxTypeModals$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = "type-tax";
  userAuthenticated: UserModel = new UserModel();
  constructor(private confirmDialogService: ConfirmDialogService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private taxTypeService: TaxTypeService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    await Promise.all([
      this.getColumnsForConsultation(),
      this.getTaxTypesForConsultation(),
    ]);
    this.getPermission();
    this.subscription = this.inputsForTaxType$.subscribe(async ({ type }) => {
      switch (type) {
        case 'reload':
          await this.getTaxTypesForConsultation();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }



  async deleteTaxType(taxType: TaxTypeTableModel) {
    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el tipo impuesto "${taxType.name}"?`)) {
      try {
        await firstValueFrom(this.taxTypeService.deleteTaxType(taxType.taxTypeId));
        this.toastHandlerService.showToast(
          'success',
          'El tipo impuesto fue eliminado exitosamente.'
        );
        this.getTaxTypesForConsultation();
      } catch (error) {
        console.error('Error al eliminar el tipo impuesto.', error);
      }
    }
  }

  async getColumnsForConsultation() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.taxTypeService.getColumnsForConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getTaxTypesForConsultation() {
    try {
      this.data = await firstValueFrom(this.taxTypeService.getTaxTypesForConsultation(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error al buscar los tipos de inventario.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.TaxType));
  }

  openModalTaxType() {
    if (!this.validations()) return;

    this.updateInput(new TaxTypeModel);
  }

  onAction(event: { action: string, item?: TaxTypeTableModel, selectedItems?: number[] }) {
    if (!this.validations()) return;

    if (event.action === 'edit' && event.item) {
      const taxTypeModel = new TaxTypeModel;
      taxTypeModel.taxTypeId = event.item.id;
      taxTypeModel.countryId = event.item.countryId;
      taxTypeModel.code = event.item.code;
      taxTypeModel.name = event.item.name;
      taxTypeModel.jurisdictionId = event.item.jurisdictionId;
      this.updateInput(taxTypeModel)
    }
    if (event.action === 'delete' && event.item) {
      this.deleteTaxType(event.item);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getTaxTypesForConsultation();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadList(reload: boolean) {
    if (reload) {
      this.getTaxTypesForConsultation();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInput(taxTypeContract: TaxTypeModel) {
    this.inputsForTaxType$.next({
      taxTypeModel: taxTypeContract,
    });
    this.taxTypeModalComponent && this.taxTypeModalComponent.show();
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar los tipos impuesto. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    return true;
  }
}
